import dayjs from 'dayjs';
import Env from '@naruto/bgdapp/src/env';
import PackageJson from '@naruto/bgdapp/package.json';
import { PrintItem } from './types';

const getDebugData = (env: typeof Env): PrintItem[] => [
  {
    name: 'Build In APP_NAME ::: ',
    value: PackageJson.name
  },
  {
    name: 'Build In APP_ENV ::: ',
    value: env.config.EnvName
  },
  {
    name: 'Build In NODE_ENV ::: ',
    value: env.config.NodeEnv
  },
  {
    name: 'Build In JWT Name ::: ',
    value: env.config.JwtTokenLocalName
  },
  {
    name: 'Build In I18n Name ::: ',
    value: env.config.I18nLocalName
  },
  {
    name: 'Build In Version ::: ',
    value: PackageJson.version
  },
  {
    name: 'Build In Git Commit Hash ::: ',
    value: env.config.GitCommitHash
  },
  {
    name: 'Build In Git Commit Time ::: ',
    value: dayjs(env.config.GitCommitTime).tz('Asia/Taipei').format('YYYY/MM/DD HH:mm:ss')
  }
];

export default getDebugData;
